var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{attrs:{"size":_vm.size,"color":_vm.color}},[(_vm.iconPath)?_c('v-img',{attrs:{"src":_vm.iconPath}}):_c('p',{staticClass:"ma-0 font-weight-bold"},[_vm._v(_vm._s(_vm.Initials))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }